export default __webpack_public_path__ + "static/media/OasisPokerBG.d7007f55.webp";